import photo1 from "../assets/home-pictures/L&N_Engaged-177.jpg"
import photo3 from "../assets/home-pictures/L&N_Engaged-225.jpg"
import photo5 from "../assets/home-pictures/L&N_Engaged-278.jpg"
import photo7 from "../assets/home-pictures/L&N_Engaged-292.jpg"
import photo2 from "../assets/home-pictures/L&N_Engaged-305.jpg"
import photo4 from "../assets/home-pictures/L&N_Engaged-437.jpg"
import photo6 from "../assets/home-pictures/L&N_Engaged-502.jpg"
import photo8 from "../assets/home-pictures/L&N_Engaged-680.jpg"


export type HomePictureDataEntry = {
    id: string;
    image: string;
}

let HomePictureData: HomePictureDataEntry[] = [
    {
        id: "1",
        image: photo1,
    },
    {
        id: "2",
        image: photo2,
    },
    {
        id: "3",
        image: photo3,
    },
    {
        id: "4",
        image: photo4,
    },
    {
        id: "5",
        image: photo5,
    },
    {
        id: "6",
        image: photo6,
    },
    {
        id: "7",
        image: photo7,
    },
    {
        id: "8",
        image: photo8,
    },
];

export default HomePictureData;